import { Navigate, useSearchParams } from 'react-router';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token') ?? '';
  const email = searchParams.get('email') ?? '';

  /**
   * If the user arrives at this page without a token or email search param,
   * then show them the password reset request form.
   */
  if (!token || !email) {
    return <Navigate to="/reset-password/request" replace />;
  }

  const encodedToken = encodeURIComponent(token);
  const encodedEmail = encodeURIComponent(email);

  return (
    <Navigate
      to={`/reset-password/complete?token=${encodedToken}&email=${encodedEmail}`}
      replace
    />
  );
}
